"use strict";

var _classCallCheck = require("/Users/davidx/projects/unishell/wallet/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/davidx/projects/unishell/wallet/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/Users/davidx/projects/unishell/wallet/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/davidx/projects/unishell/wallet/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/davidx/projects/unishell/wallet/node_modules/@babel/runtime/helpers/inherits");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var prosemirror_state_1 = require("prosemirror-state");

var prosemirror_view_1 = require("prosemirror-view");

var Extension_1 = __importDefault(require("../lib/Extension"));

var prosemirror_utils_1 = require("prosemirror-utils");

var findCollapsedNodes_1 = __importDefault(require("../queries/findCollapsedNodes"));

var headingToSlug_1 = require("../lib/headingToSlug");

var Folding =
/*#__PURE__*/
function (_Extension_1$default) {
  _inherits(Folding, _Extension_1$default);

  function Folding() {
    _classCallCheck(this, Folding);

    return _possibleConstructorReturn(this, _getPrototypeOf(Folding).apply(this, arguments));
  }

  _createClass(Folding, [{
    key: "name",
    get: function get() {
      return "folding";
    }
  }, {
    key: "plugins",
    get: function get() {
      var _this = this;

      var loaded = false;
      return [new prosemirror_state_1.Plugin({
        view: function view(_view) {
          loaded = false;

          _view.dispatch(_view.state.tr.setMeta("folding", {
            loaded: true
          }));

          return {};
        },
        appendTransaction: function appendTransaction(transactions, oldState, newState) {
          if (loaded) return;

          if (!transactions.some(function (transaction) {
            return transaction.getMeta("folding");
          })) {
            return;
          }

          var modified = false;
          var tr = newState.tr;
          var blocks = prosemirror_utils_1.findBlockNodes(newState.doc);
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = blocks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var block = _step.value;

              if (block.node.type.name === "heading") {
                var persistKey = headingToSlug_1.headingToPersistenceKey(block.node, _this.editor.props.id);
                var persistedState = localStorage === null || localStorage === void 0 ? void 0 : localStorage.getItem(persistKey);

                if (persistedState === "collapsed") {
                  tr.setNodeMarkup(block.pos, undefined, Object.assign(Object.assign({}, block.node.attrs), {
                    collapsed: true
                  }));
                  modified = true;
                }
              }
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }

          loaded = true;
          return modified ? tr : null;
        },
        props: {
          decorations: function decorations(state) {
            var doc = state.doc;
            var decorations = findCollapsedNodes_1.default(doc).map(function (block) {
              return prosemirror_view_1.Decoration.node(block.pos, block.pos + block.node.nodeSize, {
                class: "folded-content"
              });
            });
            return prosemirror_view_1.DecorationSet.create(doc, decorations);
          }
        }
      })];
    }
  }]);

  return Folding;
}(Extension_1.default);

exports.default = Folding;